import { useDocumentTitle } from "../hooks/useDocumentTitle";

export function AboutPage() {
  useDocumentTitle("About — Pilot Mastery Academy");

  return (
    <div className="mx-auto max-w-3xl px-4 py-16">
      <h1 className="font-display text-4xl font-semibold text-white">About</h1>
      <p className="mt-6 text-lg text-slate-300">
        Pilot Mastery Academy helps professional pilots make sharper decisions, protect and grow wealth, and navigate
        career transitions with evidence-based systems—not generic self-help.
      </p>
      <h2 className="mt-12 font-display text-2xl font-semibold text-white">Brand pillars</h2>
      <ul className="mt-4 space-y-4 text-slate-400">
        <li>
          <strong className="text-slate-200">Competence</strong> — Domain-specific frameworks with case patterns and
          citations where appropriate.
        </li>
        <li>
          <strong className="text-slate-200">Control</strong> — Reduce avoidable risk through checklists and scenarios.
        </li>
        <li>
          <strong className="text-slate-200">Community</strong> — Cohorts and moderated spaces with clear codes of
          conduct.
        </li>
      </ul>
      <h2 className="mt-12 font-display text-2xl font-semibold text-white">Voice</h2>
      <p className="mt-4 text-slate-400">
        Direct, expert, humble, inclusive—commercial, corporate, military transition, and regional paths all belong
        here. We avoid fear-based accident imagery and guaranteed financial or placement outcomes.
      </p>
    </div>
  );
}
